import { createLogic } from "redux-logic";
import * as ActionTypes from "../../actions/actionTypes";
import * as controlPanelActions from "../../actions/controlPanelActions";

const createAppFailLogic = createLogic({
	type: ActionTypes.CREATE_APP_FAIL,
	latest: true,
	// eslint-disable-next-line no-unused-vars
	process({ getState, action }, dispatch, done) {
		dispatch(controlPanelActions.displayError(action.error.message));
		done();
	},
});

export default [createAppFailLogic];
